import { connect } from 'react-redux';
import { setUser } from '../../actions/index';
import Signin from '../../components/Signin/Signin';

const mapStateToProps = state => {
    return {
        user: state.user,
    }
};

export default connect(
    mapStateToProps,
    { setUser }
)(Signin);


// WEBPACK FOOTER //
// ./src/containers/Signin/SigninContainer.js